import React from 'react'
import DriverFormUpdated from './DriverFormUpdated'

const DriveWithUs = () => {
    return (
        <div className="home-topbg flex items-center">
            <div className="overlay"></div>
            <div className="container relative z-10 py-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 text-white gap-10">
                    <div className="flex flex-col justify-center items-center h-full">
                        <div>
                            <div className="text-xl">Join Today</div>
                            <div className="mt-3 text-2xl md:text-5xl font-medium">
                                Make Money Driving With Shipley Central In Shipley & Surrounding Areas
                            </div>
                        </div>
                    </div>
                    <div className='text-black'>
                        <DriverFormUpdated />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default DriveWithUs